/*
 *
 * TemplatesPage constants
 *
 */

export const FETCH_TEMPLATES = 'app/TemplatesPage/FETCH_TEMPLATES';
export const FETCH_TEMPLATES_SUCCESS =
  'app/TemplatesPage/FETCH_TEMPLATES_SUCCESS';
export const FETCH_TEMPLATES_ERROR = 'app/TemplatesPage/FETCH_TEMPLATES_ERROR';

export const sortByEnum = {
  TIME_CREATED: 'timeCreated',
  NAME: 'name',
  DEFAULT_ORDER: 'defaultOrder',
};
export const sortOrderEnum = {
  ASCENDING: 'asc',
  DESCENDING: 'desc',
};

export const TEMPLATE_TAG_COLOR_MAP = {
  NPS: '#b6d6fe',
  'Van Westendorp': '#e7e1f3',
  'Maxx/Diff': '#f0c5b4',
  'Gabor Granger': '#d0dbf0',
  Conjoint: '#f8b973',
  MaxDiff: '#c9e6f1',
  'A/B testing': '#acd3cc',
  Tracker: '#eef3f7',
  unknown: '#f9fafc',
};

export const TEMPLATE_SEARCH_FIELDS = [
  'shortDescription',
  'description',
  'name',
];

export const DEFAULT_TREE_ID = 'all';
